import React from 'react'
import Cover from './Cover'
import Resultados from './Resultados'
import AvalAndares from './AvalAndares'
import Separator from '../../../../../components/helpers/Separator'

const DiagnosticoDeSegurancaContent = ({ headerValues, diagSegValues }) => {
  headerValues = {
    tipo: 'CHECKLIST - DIAGNÓSTICO DE SEGURANÇA',
    titulo: 'AVALIAÇÃO DA SITUAÇÃO ATUAL',
    ...headerValues
  }

  return (
    <>
      <Cover
        headerValues={{
          tipo: 'CHECKLIST - DIAGNÓSTICO DE SEGURANÇA',
          titulo: 'ANEXO 02 - CAPA DIAGNÓSTICO DE SEGURANÇA',
          ...headerValues
        }}
      />
      <Separator weight={10} />
      <Resultados headerValues={headerValues} diagSegValues={diagSegValues} />
      {diagSegValues.map(item => {
        return <AvalAndares headerValues={headerValues} item={item} key={item.type} />
      })}
    </>
  )
}

export default DiagnosticoDeSegurancaContent
